import React, { useEffect, useState } from "react";
import "./Driver.css";
import ReactPlayer from "react-player";
import { useNavigate } from "react-router-dom";

const DriversMotivation = () => {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.setItem("prevMessagePage", false);
  }, []);

  const [activeSteps, setActiveSteps] = useState(() => {
    const savedSteps = localStorage.getItem("activeSteps");
    return savedSteps ? JSON.parse(savedSteps) : [1];
  });

  const handleStepClick = (step) => {
    setActiveSteps((prevSteps) => {
      if (!prevSteps.includes(step)) {
        const updatedSteps = [...prevSteps, step];
        console.log(updatedSteps, "step clicked---");
        localStorage.setItem("activeSteps", JSON.stringify(updatedSteps));
        return updatedSteps;
      }
      return prevSteps;
    });
  };

  const navigateToStep = (step, driver) => {
    navigate(`/onboarding-driver/${driver}`);
    handleStepClick(step);
  };

  const editStep = (step, driver) => {
    navigate(`/onboarding-driver/${driver}/edit`);
    handleStepClick(step);
  };

  return (
    <main className="auth">
      <div className="auth-layout">
        <div className="auth-view">
          <div className="driver-auth-view__container">
            <div className="driver-view">
              <div className="driver-heading">DRIVERS AND MOTIVATIONS</div>
              <form className="driver-form">
                <div className="driver-view__field">
                  <ReactPlayer
                    url="https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/stg90-01-introduction.mp4"
                    config={{
                      vimeo: {
                        playerOptions: {
                          title: true,
                          byline: false,
                          portrait: false,
                        },
                      },
                    }}
                    controls={true}
                    width="100%"
                    height="100%"
                  />
                </div>

                <form className="driver-steps-form">
                  {/* Step 1 */}
                  <div className="driver-step-btn">
                    <button
                      type="button"
                      className="driver-btn"
                      style={{
                        width: "480px",
                        margin: "1rem 0",
                        border: "1px solid #d1b794",
                        backgroundColor:
                          activeSteps.length === 1 ? "#d1b794" : "#26262f",
                        cursor: activeSteps.includes(1)
                          ? "pointer"
                          : "not-allowed",
                      }}
                      onClick={() =>
                        activeSteps.length > 1
                          ? editStep(2, "credo")
                          : navigateToStep(2, "credo")
                      }
                    >
                      <span
                        className="driver-button__label"
                        style={
                          activeSteps.length > 1
                            ? { color: "#d1b794" }
                            : { color: "#fff" }
                        }
                      >
                        {activeSteps.length > 1
                          ? "Edit your Credo"
                          : "Step 1 | Write your credo"}
                      </span>
                    </button>
                    <div
                      style={{ cursor: "pointer", color: "#d1b794" }}
                      onClick={() => handleStepClick(2)}
                    >
                      {activeSteps.length === 1 && "Skip for now"}
                    </div>
                  </div>

                  {/* Step 2 */}
                  <div className="driver-step-btn">
                    <button
                      type="button"
                      className="driver-btn"
                      style={{
                        width: "480px",
                        margin: "1rem 0",
                        backgroundColor:
                          activeSteps.length === 2 ? "#d1b794" : "#26262f",
                        cursor: activeSteps.includes(2)
                          ? "pointer"
                          : "not-allowed",
                        border:
                          activeSteps.length === 1
                            ? "1px solid #604b51"
                            : "1px solid #d1b794",
                      }}
                      disabled={
                        activeSteps.length === 1
                      }
                      onClick={() =>
                        activeSteps.length > 2
                          ? editStep(3, "ignition")
                          : navigateToStep(3, "ignition")
                      }
                    >
                      <span
                        className="driver-button__label"
                        style={
                          activeSteps.length === 1
                            ? { color: "#604b51" }
                            : activeSteps.length > 2
                            ? { color: "#d1b794" }
                            : { color: "#fff" }
                        }
                      >
                        {activeSteps.length > 2
                          ? "Edit your Ignition Statement"
                          : "Step 2 | Write your ignition statement"}
                      </span>
                    </button>
                    <div
                      style={
                        activeSteps.includes(2)
                          ? {
                              display: "flex",
                              cursor: "pointer",
                              color: "#d1b794",
                            }
                          : { display: "none" }
                      }
                      onClick={() => handleStepClick(3)}
                    >
                      {activeSteps.length === 2 && "Skip for now"}
                    </div>
                  </div>

                  {/* Step 3 */}
                  <div className="driver-step-btn">
                    <button
                      type="button"
                      className="driver-btn"
                      style={{
                        width: "480px",
                        margin: "1rem 0",
                        backgroundColor:
                          activeSteps.length === 3 ? "#d1b794" : "#26262f",
                        cursor: activeSteps.includes(3)
                          ? "pointer"
                          : "not-allowed",
                        border:
                          activeSteps.length < 3
                            ? "1px solid #604b51"
                            : "1px solid #d1b794",
                      }}
                      disabled={!activeSteps.includes(3)}
                      onClick={() => navigateToStep(3, "gap-map")}
                    >
                      <span
                        className="driver-button__label"
                        style={
                          activeSteps.length < 3
                            ? { color: "#604b51" }
                            : { color: "#fff" }
                        }
                      >
                        Step 3 | Create your gap map
                      </span>
                    </button>
                    <div
                      style={
                        activeSteps.includes(3)
                          ? {
                              display: "block",
                              cursor: "pointer",
                              color: "#d1b794",
                            }
                          : { display: "none" }
                      }
                      onClick={() => navigate("/plan-for-success")}
                    >
                      Skip for now
                    </div>
                  </div>
                </form>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default DriversMotivation;
